<div #main class="flex-col height100p">
    <sm-toolbar class="flex-item-fixed">
        <button pButton icon="fas fa-save" label="Benutzer und Gruppen als Excel-Datei speichern" (click)="exportUsersToXlsx()"></button>
    </sm-toolbar>
    <div #main class="flex-item-fill flex-row-split">
        <p-listbox *ngIf="inited" class="flex-item-fixed width300 full-height tree-items-full-width" [options]="users" optionLabel="userName" optionValue="userName" selectionMode="single" [filter]=true filterBy="userName,fullName"
            [(ngModel)]="selectedUser" (onChange)="selectUser()">
        </p-listbox>
        <p-tabView class="flex-item-fill height100p full-height direct-sub" [class.hidden]="selectedUser == null">
            <p-tabPanel header="Benutzerrechte">
                <div class="flex-col height100p">
                    <sm-toolbar>
                        <span class="mr-3">Schrank:<p-dropdown class="ml-2" styleClass="width400" [options]="archivesGui" [(ngModel)]="selectedArchive" (onChange)="run()"></p-dropdown></span>
                        <span class="mr-3">Vergleichen mit:<p-dropdown class="ml-2" styleClass="width300" [options]="compareToUsersGui" [(ngModel)]="selectedCompareToUser" (onChange)="run()"></p-dropdown></span>
                    </sm-toolbar>
                    <sm-table2 *ngIf="userTable != null" class="flex-item-fill height100p"  [data]="userTable"></sm-table2>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Benutzerkonfiguration">
                <sm-table2 *ngIf="prefsTable != null" class="height100p"  [data]="prefsTable"></sm-table2>
            </p-tabPanel>
            <p-tabPanel *ngIf="devMode" header="Erweitert">
                <div class="flex-col height100p">
                    <sm-toolbar>
                        <button pButton icon="fas fa-eye" label="PW holen" (click)="getPw()"></button>
                        <button pButton icon="fas fa-eye" label="PW ändern" (click)="changePw()"></button>
                    </sm-toolbar>
                    <div class="flex-item-fill">
                        Passwort verschlüsselt: {{pw[0]}}
                        <br>
                        Passwort: {{pw[1]}}
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>